import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgExport = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M13.471 6.471a.75.75 0 0 1 0 1.058L8 13 2.532 7.532a.753.753 0 1 1 1.065-1.064l3.653 3.66V1.75a.75.75 0 0 1 1.5 0v8.378l3.664-3.657a.75.75 0 0 1 1.057 0M2.75 13.5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgExport);
export default ForwardRef;
